// Runmode コンポーネントMixins
import { mapGetters } from "vuex";
import common from "@/mixin/common";
import audio from "@/mixin/audio";
import commonLayout from "@/mixin/commonLayout";
import lodash from "lodash";
import * as constants from "@/store/constants";
import * as mixinConstants from "@/mixin/constants";

/**
 * SP版特殊レイアウト出題順序設定index配列
 */
// layout307
export const QUESTION_ORDER_LAYOUT_307 = [0, 1, 4, 2, 3];
// layout327
export const QUESTION_ORDER_LAYOUT_327 = [0, 1, 3, 4, 5, 2, 6, 7];

export default {
  props: {
    pathstep: Object
  },
  data() {
    return {
      // オーディオオブジェクト
      audioContext: null,
      audioPlaying: false,
      // 現在のact
      currentAct: null,
      // 現在のactのindex
      currentActIndex: 0,
      // 音声リプレイフラグ
      isAudioReplay: false,
      // 音声リプレイ可能フラグ
      enableAudioReplay: false,
      // タイマー処理変数
      timer: null,
      myAudio: null,
      // 不正解画像表示時間
      incorrectImageDuration: 1000,
      // Runmode用swiper外側
      swiperOut: null,
      // Runmode用swiper内側
      swiperIn: null,
      // 画面表示済みフラグ
      isAutoAdjustShown: false,
      // 自動調整設定
      topAreaHeight: {},
      topAreaFontSize: {},
      cardAreaHeight: {},
      cardAreaFontSize: {},
      // Tile表示サイズ基準値
      tileSize: 0
    };
  },
  mixins: [
    common,
    audio,
    commonLayout
  ],
  mounted() {
    // Safariのブラウザ縮小時の高さ調整
    var ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("safari") !== -1 && ua.indexOf("chrome") === -1) {
      this.fixtHeightForSafariFullWindow();
    }

    if (this.pathstep != null) {
      this.common_init();
    }

    this.tileSize = mixinConstants.AUTO_ADJUST_FONT_SIZE[this.textSize].max;
  },
  beforeDestroy: function() {
    this.destroyRunmode();
  },
  computed: {
    ...mapGetters([
      "lessonState",
      "sreUse",
      "scriptType",
      "displayMode",
      "textSize"
    ]),
    dispAllAnswerStatus: function() {
      return this.$store.getters.showAllAnswer;
    },
    cssLayoutID: function() {
      return "layout" + this.pathstep.layoutID;
    },
    layoutObj: function() {
      return this.getLayoutObject(this.pathstep.layoutID);
    },
    answerSoundMute: function() {
      // 解答音ミュートフラグ
      return this.$store.getters.answerSound == "true" ? false : true;
    },
    tileStyles: function() {
      return {
        "--tileHeight": String(this.tileSize) + "px",
        "--tileWidth": String(this.tileSize + 6) + "px",
        "--tileNumberSize": String(this.tileSize - 4) + "px"
      }
    }
  },
  methods: {
    // 共通初期化処理
    common_init: function() {
      // オーディオ初期化
      this.myAudio = new Audio();
      // オーディオロード
      this.currentAct = this.pathstep.acts[this.currentActIndex];
      var that = this;
      this.myAudio.onended = function() {
        // 再生終了時処理
        that.audioPlaying = false;
        that.audioEnded();
      };
    },
    // Runmode破棄時の処理
    destroyRunmode: function() {
      clearTimeout(this.timer);

      if (this.myAudio != null) {
        this.myAudio.pause();
        this.myAudio = null;
      }
    },
    /**
     * 音声認識を利用するRunmode(P系)かどうかを判別する
     *
     * @returns {Boolean} P系Runmodeかどうか
     */
    isPseriesRumode: function() {
      switch (this.pathstep.mode) {
        case mixinConstants.RUNMODE_P:
        case mixinConstants.RUNMODE_PNT:
        case mixinConstants.RUNMODE_PNS:
        case mixinConstants.RUNMODE_PSPEECH:
        case mixinConstants.RUNMODE_PNTSPEECH:
        case mixinConstants.RUNMODE_SPEECH:
          return true;
          break;
        default:
          return false;
          break;
      }
    },
    // 次のactへ
    setNextAct: function(func) {
      if (this.currentActIndex < this.pathstep.acts.length - 1) {
        // 次のアクトへ
        this.currentActIndex++;
        this.currentAct = this.pathstep.acts[this.currentActIndex];
        if (func) {
          this.$nextTick(func);
        }
        return true;
      } else {
        // 結果表示処理
        return false;
      }
    },
    getShuffleActs: function() {
      // shuffle
      var acts = JSON.parse(JSON.stringify(this.pathstep.acts));
      var j, x, i;
      for (i = acts.length; i; i -= 1) {
        j = Math.floor(Math.random() * i);
        x = acts[i - 1];
        acts[i - 1] = acts[j];
        acts[j] = x;
      }
      return acts;
    },
    // 音声再生
    audioPlay: function(audioPath) {
      if (this.audioPlaying) {
        // 再生中は何もしない
        return;
      }
      if (!this.myAudio.paused) {
        this.myAudio.pause();
      }
      this.audioPlaying = true;
      this.myAudio.src = audioPath;
      this.myAudio.play();
    },
    // 自動再生
    autoPlay: function(audioPath, duration) {
      this.isAudioReplay = false;
      duration = duration === undefined ? 2000 : duration;
      var that = this;
      this.timer = setTimeout(function() {
        that.audioPlay(audioPath);
      }, duration);
    },
    // 音声リプレイ
    audioReplay: function(audioPath) {
      if (this.enableAudioReplay) {
        this.isAudioReplay = true;
        this.audioPlay(audioPath);
      }
    },
    // 選択中のACTクラス
    classActActive: function(index) {
      if (index === this.currentActIndex) {
        return { active: true };
      } else {
        return { active: false };
      }
    },
    /**
     * テキストサイズの取得
     *
     * @param {String} text サイズ取得対象のテキスト
     * @param {Stirng} language 言語コード
     *
     * @return テキストサイズ
     *
     */
    getTextSize: function(text, language) {
      if (text == undefined) {
        return null;
      }
      var replaceText = text
      
      // 日本語の場合はルビの文字を削除する（中国語はルビの文字を含めた文字数でサイズ調整しているので削除しない）
      if(language === mixinConstants.LANGUAGE_CODE_JAJP) {
        
        var startStr = "<rt>";
        var endStr = "</rt>";
        var i = 0;
        // <rt>タグ（タグ内の文字列）をすべて削除するまで繰り返す（無限ループをしないよう上限を100とする）
        while(i < 100) {
          
          var startIndex = replaceText.indexOf(startStr);
          // <rt>タグがない場合はループ処理を終了する
          if(startIndex === -1) {
            break;
          }
          
          var endIndex = replaceText.indexOf(endStr) + endStr.length;
          var deleteStr = replaceText.substr(startIndex, (endIndex - startIndex));
          var regExp = new RegExp(deleteStr, "g");
          replaceText = replaceText.replace(regExp, "");
          i++;
        }
      }
      
      // htmlタグと空白を除去
      replaceText = replaceText.replace(/<.+?>|&nbsp;/g, "");

      var textLength = 0;
      for (var i = 0; i < replaceText.length; i++) {
        var str = replaceText.substring(i, i + 1);
        var result = str.match(/^[^\x01-\x7E\xA1-\xDF]+$/) ? true : false;
        if (result) {
          textLength += 2;
        } else {
          textLength += 1;
        }
      }
      return textLength;
    },
    /**
     * 初回7言語かを判定する
     *
     * @param {String} language 言語コード
     *
     * @return {Boolean} true: 初回7言語, false: 追加17言語
     */
    isFirstLang: function(language) {
      switch (language) {
        case mixinConstants.LANGUAGE_CODE_ENUS:
        case mixinConstants.LANGUAGE_CODE_ZHCV:
        case mixinConstants.LANGUAGE_CODE_DEDE:
        case mixinConstants.LANGUAGE_CODE_FRFR:
        case mixinConstants.LANGUAGE_CODE_ITIT:
        case mixinConstants.LANGUAGE_CODE_KOKR:
        case mixinConstants.LANGUAGE_CODE_ESES:
          return true;
        default:
          return false;
      }
    },
    /**
     * Act部分のテキストフォントクラスを取得する
     *
     * @param {String} text 判定対象のテキスト
     * @param {String} language 言語コード
     *
     * @return {String} 適用するクラス名
     */
    getTextFontClassAct: function(text, language) {
      var textSize = this.getTextSize(text, language);

      if (!language) {
        return this.getFontActFirstLang(textSize);
      }

      if (this.isFirstLang(language)) {
        // 初回7言語
        return this.getFontActFirstLang(textSize);
      } else {
        // 追加17言語
        return this.getShrinkFontClass(this.getFontActAfterLang(textSize), language);
      }
      return "";
    },
    /**
     * 初回7言語のAct部分のテキストフォントクラスを取得する
     *
     * @param {Int} textSize テキストサイズ
     *
     * @return {String} 適用するクラス名
     */
    getFontActFirstLang: function(textSize) {
      if (!textSize) {
        return "";
      }

      if (this.isEnvironmentPc()) {
        if (textSize <= 12) {
          return "font28";
        } else if (textSize <= 42) {
          return "font18";
        } else if (textSize <= 63) {
          return "font15";
        } else if (textSize <= 80) {
          return "font13";
        } else if (textSize <= 130) {
          return "font11";
        } else {
          return "font10";
        }
      } else {
        if (textSize <= 18) {
          return "font28";
        } else if (textSize <= 33) {
          return "font24";
        } else if (textSize <= 38) {
          return "font21";
        } else if (textSize <= 63) {
          return "font18";
        } else if (textSize <= 84) {
          return "font15";
        } else if (textSize <= 141) {
          return "font13";
        } else {
          return "font11";
        }
      }
      return "";
    },
    /**
     * 追加17言語のAct部分のテキストフォントクラスを取得する
     *
     * @param {Int} textSize テキストサイズ
     *
     * @return {String} 適用するクラス名
     */
    getFontActAfterLang: function(textSize) {
      if (!textSize) {
        return "";
      }

      if (this.isEnvironmentPc()) {
        if (textSize <= 9) {
          return "font28";
        } else if (textSize <= 43) {
          return "font18";
        } else if (textSize <= 65) {
          return "font15";
        } else if (textSize <= 78) {
          return "font13";
        } else {
          return "font10";
        }
      } else {
        if (textSize <= 18) {
          return "font28";
        } else if (textSize <= 28) {
          return "font24";
        } else if (textSize <= 51) {
          return "font18";
        } else if (textSize <= 78) {
          return "font15";
        } else if (textSize <= 131) {
          return "font13";
        } else {
          return "font11";
        }
      }
      return "";
    },
    /**
     * Act部分のテキストフォントクラスを取得する（拡大表示）
     *
     * @param {String} text 判定対象のテキスト
     * @param {String} language 言語コード
     *
     * @return {String} 適用するクラス名
     */
    getPinchInTextFontclassAct: function(text, language) {
      // 拡大表示しない場合のfontクラスをn倍して返却（小数点以下切り捨て）
      var fontSize = this.getTextFontClassAct(text, language).replace(/[^0-9]/g, "");
      if (this.isEnvironmentPc()) {
        fontSize = fontSize * mixinConstants.DISP_MAGNIFICATION_PC;
      } else {
        fontSize = fontSize * mixinConstants.DISP_MAGNIFICATION_MOBILE;
      }
      return "font" + Math.floor(fontSize);
    },
    /**
     * Act部分のテキストフォントクラスを取得する（milestone）
     *
     * @param {String} text 判定対象のテキスト
     * @param {String} language 言語コード
     *
     * @return {String} 適用するクラス名
     */
    getMilestoneTextFontClassAct: function(text, language) {
      if(this.isEnvironmentPc()) {
        // PC版は他のRunmodeのAct部分の同様の設定
        return this.getTextFontClassAct(text, language);
      } else {
        var textSize = this.getTextSize(text, language);
        var fontClass = "";
        
        // スマホ版は領域幅が小さいので独自に設定
        if (textSize <= 10) {
          fontClass = "font28";
        } else if (textSize <= 12) {
          fontClass = "font24";
        } else if (textSize <= 15) {
          fontClass = "font18";
        } else if (textSize <= 80) {
          fontClass = "font15";
        } else {
          fontClass = "font13";
        }
        
        return this.getShrinkFontClass(fontClass, language);
      }
    },
    /**
     * 出題部分のテキストフォントクラスを取得する
     *
     * @param {String} text 判定対象のテキスト
     * @param {String} language 言語コード
     *
     * @return {String} 適用するクラス名
     */
    getTextFontClassQue: function(text, language) {
      var textSize = this.getTextSize(text, language);

      if (!language) {
        return this.getFontQueFirstLang(textSize);
      }

      if (this.isFirstLang(language)) {
        // 初回7言語
        return this.getFontQueFirstLang(textSize);
      } else {
        // 追加17言語
        return this.getShrinkFontClass(this.getFontActAfterLang(textSize), language);
      }
      return "";
    },
    /**
     * 初回7言語の出題部分のテキストフォントクラスを取得する
     *
     * @param {Int} textSize テキストサイズ
     *
     * @return {String} 適用するクラス名
     */
    getFontQueFirstLang: function(textSize) {
      if (!textSize) {
        return "";
      }

      if (this.isEnvironmentPc()) {
        if (textSize <= 22) {
          return "font28";
        } else if (textSize <= 28) {
          return "font24";
        } else if (textSize <= 63) {
          return "font18";
        } else if (textSize <= 84) {
          return "font15";
        } else if (textSize <= 126) {
          return "font13";
        } else {
          return "font11";
        }
      } else {
        if (textSize <= 18) {
          return "font28";
        } else if (textSize <= 33) {
          return "font24";
        } else if (textSize <= 42) {
          return "font21";
        } else if (textSize <= 63) {
          return "font18";
        } else if (textSize <= 118) {
          return "font15";
        } else if (textSize <= 141) {
          return "font13";
        } else {
          return "font11";
        }
      }
      return "";
    },
    /**
     * 追加17言語の出題部分のテキストフォントクラスを取得する
     *
     * @param {Int} textSize テキストサイズ
     *
     * @return {String} 適用するクラス名
     */
    getFontQueAfterLang: function(textSize) {
      if (!textSize) {
        return "";
      }

      if (this.isEnvironmentPc()) {
        if (textSize <= 18) {
          return "font28";
        } else if (textSize <= 29) {
          return "font24";
        } else if (textSize <= 65) {
          return "font18";
        } else if (textSize <= 78) {
          return "font15";
        } else if (textSize <= 120) {
          return "font13";
        } else {
          return "font11";
        }
      } else {
        if (textSize <= 18) {
          return "font28";
        } else if (textSize <= 33) {
          return "font24";
        } else if (textSize <= 65) {
          return "font18";
        } else if (textSize <= 113) {
          return "font15";
        } else if (textSize <= 132) {
          return "font13";
        } else {
          return "font11";
        }
      }
      return "";
    },
    /**
     * 出題部分のテキストフォントクラスを取得する（拡大表示）
     *
     * @param {String} text 判定対象のテキスト
     * @param {String} language 言語コード
     *
     * @return {String} 適用するクラス名
     */
    getPinchInTextFontClassQue: function(text, language) {
      // 拡大表示しない場合のfontクラスをn倍して返却（小数点以下切り捨て）
      var fontSize = this.getTextFontClassQue(text, language).replace(/[^0-9]/g, "");
      if (this.isEnvironmentPc()) {
        fontSize = fontSize * mixinConstants.DISP_MAGNIFICATION_PC;
      } else {
        fontSize = fontSize * mixinConstants.DISP_MAGNIFICATION_MOBILE;
      }
      return "font" + Math.floor(fontSize);
    },
    /**
     * Tile選択肢部分のテキストフォントクラスを取得する
     *
     * @param {String} text 判定対象のテキスト
     * @param {String} language 言語コード
     *
     * @return {String} 適用するクラス名
     */
    getTextFontClassTile: function(text, language) {
      var textSize = this.getTextSize(text, language);

      if (!language) {
        return this.getFontTileFirstLang(textSize);
      }

      if (this.isFirstLang(language)) {
        // 初回7言語
        return this.getFontTileFirstLang(textSize);
      } else {
        // 追加17言語
        return this.getShrinkFontClass(this.getFontTileAfterLang(textSize), language);
      }
      return "";
    },
    /**
     * 初回7言語のTile選択肢部分のテキストフォントクラスを取得する
     *
     * @param {Int} textSize テキストサイズ
     *
     * @return {String} 適用するクラス名
     */
    getFontTileFirstLang: function(textSize) {
      if (!textSize) {
        return "";
      }

      if (this.isEnvironmentPc()) {
        if (textSize <= 14) {
          return "font28";
        } else if (textSize <= 22) {
          return "font24";
        } else if (textSize <= 27) {
          return "font21";
        } else {
          return "font18";
        }
      } else {
        if (textSize <= 14) {
          return "font28";
        } else if (textSize <= 17) {
          return "font24";
        } else if (textSize <= 19) {
          return "font21";
        } else if (textSize <= 22) {
          return "font18";
        } else {
          return "font15";
        }
      }
      return "";
    },
    /**
     * 追加17言語のTile選択肢部分のテキストフォントクラスを取得する
     *
     * @param {Int} textSize テキストサイズ
     *
     * @return {String} 適用するクラス名
     */
    getFontTileAfterLang: function(textSize) {
      if (!textSize) {
        return "";
      }

      if (this.isEnvironmentPc()) {
        if (textSize <= 11) {
          return "font28";
        } else if (textSize <= 23) {
          return "font24";
        } else if (textSize <= 25) {
          return "font21";
        } else {
          return "font18";
        }
      } else {
        if (textSize <= 11) {
          return "font28";
        } else if (textSize <= 15) {
          return "font24";
        } else if (textSize <= 18) {
          return "font21";
        } else if (textSize <= 23) {
          return "font18";
        } else {
          return "font15";
        }
      }
      return "";
    },
    /**
     * STile選択肢部分のテキストフォントクラスを取得する
     *
     * @param {String} text 判定対象のテキスト
     * @param {String} language 言語コード
     *
     * @return {String} 適用するクラス名
     *
     */
    getTextFontClassStile: function(text, language) {
      var textSize = this.getTextSize(text, language);

      if (!language) {
        return this.getFontStileFirstLang(textSize);
      }

      if (this.isFirstLang(language)) {
        // 初回7言語
        return this.getFontStileFirstLang(textSize);
      } else {
        // 追加17言語
        return this.getShrinkFontClass(this.getFontStileAfterLang(textSize), language);
      }
      return "";
    },
    /**
     * 初回7言語のSTile選択肢部分のテキストフォントクラスを取得する
     *
     * @param {Int} textSize テキストサイズ
     *
     * @return {String} 適用するクラス名
     */
    getFontStileFirstLang: function(textSize) {
      if (!textSize) {
        return "";
      }

      if (this.isEnvironmentPc()) {
        if (textSize <= 14) {
          return "font28";
        } else if (textSize <= 22) {
          return "font24";
        } else {
          return "font21";
        }
      } else {
        if (textSize <= 7) {
          return "font28";
        } else if (textSize <= 22) {
          return "font18";
        } else {
          return "font13";
        }
      }
      return "";
    },
    /**
     * 追加17言語のSTile選択肢部分のテキストフォントクラスを取得する
     *
     * @param {Int} textSize テキストサイズ
     *
     * @return {String} 適用するクラス名
     */
    getFontStileAfterLang: function(textSize) {
      if (!textSize) {
        return "";
      }

      if (this.isEnvironmentPc()) {
        if (textSize <= 11) {
          return "font28";
        } else if (textSize <= 23) {
          return "font24";
        } else {
          return "font18";
        }
      } else {
        if (textSize <= 7) {
          return "font28";
        } else if (textSize <= 22) {
          return "font18";
        } else {
          return "font12";
        }
      }
      return "";
    },
    /**
     * 縮小したフォントクラスを取得する
     *
     * @param {String} fontClass 縮小前のフォントクラス
     * @param {String} language 言語コード
     *
     * @return {String} 縮小後のフォントクラス
     */
    getShrinkFontClass: function(fontClass, language) {
      var shrinkFontClass = fontClass;
      
      // 日本語以外は縮小表示しないため、縮小前のフォントクラスをそのまま返却
      if(language !== mixinConstants.LANGUAGE_CODE_JAJP) {
        return shrinkFontClass
      }
      
      var displayMode = this.$store.getters.displayMode;
      if(displayMode === mixinConstants.DISPLAY_MODE_KANJI_WITH_KANA) {
        var fontSize = fontClass.replace(/[^0-9]/g, "");
        shrinkFontClass = "font" + Math.floor(fontSize * mixinConstants.SHRINK_FONT_KANJI_WITH_KANA);
      }
      
      return shrinkFontClass
    },
    /**
     * 画像用テキストのフォントクラスを取得する
     *
     * @param {String} language 言語コード
     * @param {String} imageText 画像用テキスト
     *
     * @return {String} 適用するクラス名
     */
    getImageTextFontClass: function(language, imageText) {
      var length = imageText.length;
      switch (language) {
        case mixinConstants.LANGUAGE_CODE_DEDE:
          if (length < 4) {
            return "font100";
          }
          if (length < 6) {
            return "font72";
          }
          return "font56";
        case mixinConstants.LANGUAGE_CODE_FRFR:
        case mixinConstants.LANGUAGE_CODE_TRTR:
        case mixinConstants.LANGUAGE_CODE_HIIN:
        case mixinConstants.LANGUAGE_CODE_FAIR:
        case mixinConstants.LANGUAGE_CODE_RURU:
          return "font100";
        case mixinConstants.LANGUAGE_CODE_ZHCV:
          if (length < 2) {
            return "font110";
          }
          if (length < 4) {
            return "font100";
          }
          if (length < 6) {
            return "font72";
          }
          return "font56";
        case mixinConstants.LANGUAGE_CODE_KOKR:
          return "font140";
        case mixinConstants.LANGUAGE_CODE_GAIE:
          switch (length) {
            case 1:
            case 2:
            case 3:
              return "font90";
            case 4:
              return "font80";
            case 5:
              return "font72";
            case 6:
              return "font64";
            case 7:
              return "font54";
            case 8:
              return "font45";
            case 9:
              return "font42";
            case 10:
            case 11:
            case 12:
              return "font40";
            case 13:
              return "font38";
            default:
              return "font28";
          }
        case mixinConstants.LANGUAGE_CODE_NLNL:
        case mixinConstants.LANGUAGE_CODE_SVSE:
          return "font72";
        case mixinConstants.LANGUAGE_CODE_ELGR:
          switch (length) {
            case 1:
            case 2:
              return "font140";
            case 3:
              return "font110";
            default:
              return "font72";
          }
        case mixinConstants.LANGUAGE_CODE_TLPH:
        case mixinConstants.LANGUAGE_CODE_PLPL:
          return "font90";
        case mixinConstants.LANGUAGE_CODE_HEIL:
          return "font110";
        case mixinConstants.LANGUAGE_CODE_VIVN:
          if (length < 5) {
            return "font90";
          }
          return "font64";
        case mixinConstants.LANGUAGE_CODE_JAJP:
          switch (length) {
            case 1:
              return "font72";
            case 2:
              return "font56";
            case 3:
              return "font42";
            case 4:
              return "font32";
            case 5:
              return "font24";
            default:
              return "font22";
          }
        default:
          if (length < 4) {
            return "font100";
          }
          if (length < 6) {
            return "font72";
          }
          return "font56";
      }
    },
    /**
     * 画像用テキストのフォントクラスを取得する（拡大表示）
     *
     * @param {String} language 言語コード
     * @param {String} imageText 画像用テキスト
     *
     * @return {String} 適用するクラス名
     */
    getPinchInImageTextFontClass: function(language, imageText) {
      var length = imageText.length;
      switch (language) {
        case mixinConstants.LANGUAGE_CODE_ZHCV:
          if (length < 4) {
            return "font140";
          }
          if (length < 6) {
            return "font100";
          }
          return "font80";
        case mixinConstants.LANGUAGE_CODE_GAIE:
          if (13 < length) {
            return "font36";
          } else {
            return this.getImageTextFontClass(language, imageText);
          }
        case mixinConstants.LANGUAGE_CODE_JAJP:
          switch (length) {
            case 1:
              return "font140";
            case 2:
              return "font100";
            case 3:
              return "font80";
            case 4:
              return "font64";
            case 5:
              return "font48";
            default:
              return "font40";
          }
        default:
          return this.getImageTextFontClass(language, imageText);
      }
    },
    setAudioEnded: function(func) {
      // 音声再生終了イベント処理セット
      if (func) {
        this.myAudio.onended = func;
      }
    },
    imageBackgroundStyle: function(img_path) {
      // 背景画像のスタイル取得
      return {
        "background-image": "url(" + img_path + ")"
      };
    },
    audioEnded: function() {
      this.log("audio endid");
    },
    /**
    /* 全問正解チェック
    /* pathstep内のchallengeのact全て正解したかを判定する
    /*
    /* @param correctIndexLength 正解した問題の数
    /* @return 全問正解の場合はtrue、それ以外はfalse
    */
    isAllCorrect: function() {
      this.log("runmode start isAllCorrect");

      var correctCont = 0;
      for (var i = 0; i < this.pathstep.acts.length; i++) {
        if (this.pathstep.acts[i].correct) {
          correctCont += 1;
        }
      }

      if (correctCont == this.getQuestionCount()) {
        return true;
      }
      return false;
    },
    /**
    /* 対象act解答有無チェック
    /*
    /* @param act チェック対象のact
    /* @return challengeはture、given,contextはfalse
    */
    isChallenge: function(act) {
      if (act.usage == 1) {
        return true;
      }
      return false;
    },
    /**
     * 対象のactがgivenかを判定する
     *
     * @param act チェック対象のact
     * @return givenはtrue、challenge,contextはfalse
     */
    isGiven: function(act) {
      if (act.usage == 0) {
        return true;
      }
      return false;
    },
    /**
     * 対象のactがcontextかを判定する
     *
     * @param act チェック対象のact
     * @return contextはtrue、challenge,givenはflase
     *
     */
    isContext: function(act) {
      if (act.usage == -1) {
        return true;
      }
      return false;
    },
    /**
    /* 画像シャッフル処理
    /* pathstep内のact配列をシャッフルして返却する
    /* シャッフルする設定かつ、グループなしの場合はシャッフルする。
    /*
    /*
    /* @param なし
    /* @return pathstep.acts シャッフル後のact配列
    */
    getShuffleItems: function() {
      this.log("runmode start getShuffleItems");

      if (this.pathstep.scramble == true) {
        if (this.pathstep.groupNum == 0) {
          // グループなしの場合
          return _.shuffle(this.pathstep.acts);
        }
      }
      return this.pathstep.acts;
    },
    /**
    /* 出題問題取得
    /* 未出題かつ、pathstep内の先頭のactを取得する
    /*
    /* @param currentIndex 出題済みのactのindex配列
    /* @return questionAct 出題対象のact
    /*
    */
    getQuestion(currentIndex) {
      this.log("runmode start getQuestion");

      for (var i = 0; i < this.pathstep.acts.length; i++) {
        // 既に出題済みかを判定する
        if (!this.pathstep.acts[i].correct) {
          if (!this.isEnvironmentPc()) {
            var questionOrderList = [];
            switch (this.pathstep.layoutID) {
              case 307:
                questionOrderList = QUESTION_ORDER_LAYOUT_307;
                break;
              case 327:
                questionOrderList = QUESTION_ORDER_LAYOUT_327;
                break;
              default:
                break;
            }
            for (var j = i; j < questionOrderList.length; j++) {
              if (!this.pathstep.acts[questionOrderList[j]].correct) {
                return { act: this.pathstep.acts[questionOrderList[j]], index: questionOrderList[j] };
              }
            }
          }
          return { act: this.pathstep.acts[i], index: i };
        }
      }

      return null;
    },
    /**
    /* pathstep内のgivenのactを全て取得し、返却する。
    /*
    /* @param なし
    /* @return givenActs givenのact配列
    /*
    */
    getGivenQuestion: function() {
      this.log("runmode start getGivenQuestion");

      var givenActs = [];

      for (var i = 0; i < this.pathstep.acts.length; i++) {
        if (this.pathstep.acts[i].challenge == 0) {
          givenActs.push(this.pathstep.acts[i]);
        }
      }
      return givenActs;
    },
    /**
    /* 出題問題取得_ランダム
    /* challengeかつ、未出題の問題をランダムで取得し、返却する
    /*
    /* @return questionAct 出題対象のact
    */
    getQuestionRandom: function() {
      this.log("runmode start getQuestionRandom");

      var questionActs = [];

      for (var i = 0; i < this.pathstep.acts.length; i++) {
        // 既に出題済みかを判定する
        if (!this.pathstep.acts[i].correct) {
          if (this.isChallenge(this.pathstep.acts[i])) {
            questionActs.push(this.pathstep.acts[i]);
          }
        }
      }

      if (questionActs.length == 0) {
        return null;
      }
      var random = Math.floor(Math.random() * questionActs.length);
      return questionActs[random];
    },
    /**
    /* 解答act数取得
    /* pathstep内のchallengeのact数を返却する
    /*
    /* @param なし
    /* @return QuestionCount challengeのact数
    */
    getQuestionCount: function() {
      this.log("runmode start getQuestionCount");
      var QuestionCount = 0;
      for (var i = 0; i < this.pathstep.acts.length; i++) {
        if (this.pathstep.acts[i].usage == 1) {
          QuestionCount += 1;
        }
      }
      return QuestionCount;
    },
    /**
    /* pathstep内のactのindex配列を取得し、返却する
    /*
    /*
    /* @param なし
    /* @return items actのindex配列
    */
    getItems: function() {
      this.log("runmode start getItems");

      var items = [];
      if (this.pathstep.groupNum != 0) {
        // グループありの場合
        for (var i = 1; i <= this.pathstep.groupNum; i++) {
          var groupItems = [];
          for (var j = 0; j < this.pathstep.acts.length; j++) {
            if (this.pathstep.acts[j].group == i) {
              groupItems.push(j);
            }
          }
          items.push(groupItems);
        }
        return items;
      } else {
        // グループなしの場合
        for (var i = 0; i < this.pathstep.acts.length; i++) {
          items.push(i);
        }
        return items;
      }
      return items;
    },
    /**
    /* 解答用テキストの取得
    /* 正解のテキストを含む解答用のact配列を取得する（最大３件）
    /* Runmode:A1Q,NR系(NR1,NR2,NR3,NR3_NT)での使用を想定
    /*
    /* @param correctText 正解となるテキスト
    /* @return answerActs 解答用のact配列
    */
    getAnswers: function(correctText) {
      this.log("runmode start getAnswers");

      var answerActs = []; // 返却値
      var tmpAnswerActs = []; // 退避用のact配列
      var alreadyGetIndex = []; // 取得済みのactのIndex配列

      for (var i = 0; i < this.pathstep.acts.length; i++) {
        if (this.isChallenge(this.pathstep.acts[i])) {
          // challengeのactを全てを取得する
          tmpAnswerActs.push(this.pathstep.acts[i]);
        }
      }

      if (tmpAnswerActs.length >= 3) {
        // challengeのactが３件以上の場合は、３件に絞る
        for (var i = 0; i < tmpAnswerActs.length; i++) {
          if (tmpAnswerActs[i].texts[0].basicText == correctText) {
            // 正解となるテキストを取得する
            answerActs.push(tmpAnswerActs[i]);
            alreadyGetIndex.push(i);
            break;
          }
        }

        for (var i = 0; i < 2; i++) {
          // 残り２件のテキストをランダム取得する
          var random = Math.floor(Math.random() * tmpAnswerActs.length);

          while (alreadyGetIndex.indexOf(random) != -1) {
            // 既に取得済みの場合は、取得対象から除外する
            random = Math.floor(Math.random() * tmpAnswerActs.length);
          }
          answerActs.push(tmpAnswerActs[random]);
          alreadyGetIndex.push(random);
        }
      } else {
        answerActs = tmpAnswerActs;
      }

      return _.shuffle(answerActs);
    },
    /**
    /* 問題解答時のステータスを設定する
    /*
    /* @param state 正解の場合はtrue、不正解の場合はfalse
    /* @return なし
    */
    setActState: function(state) {
      this.log("runmode start setActState");

      if (state == true) {
        this.$store.dispatch("setCurrentPathstep", constants.ACT_STATE_OK);
      } else {
        this.$store.dispatch("setCurrentPathstep", constants.ACT_STATE_NG);
      }
    },
    /**
    /* 音声再生後、次の音声を再生する／全問正解後、次の問題を出題する等、一定の間隔を空けたい場合に使用する
    /* 呼び出し元は返値のPromiseが成功（resolve）した後に次の処理を実行するよう設定する
    /*
    /* @param time 間隔を空けるミリ秒を設定する（/src/mixin/constants.jsの処理間隔を設定する）
    /* @return Promise
     */
    setInterval: function(time) {
      this.log("runmode start questionInterval");

      return new Promise(function(resolve, reject) {
        setTimeout(function() {
          resolve();
        }, time);
      });
    },
    /**
     * 音声停止処理
     */
    runmodeAudioPause: function() {
      this.log("runmode start audioPause");

      if (this.myAudio != null && !this.myAudio.paused) {
        this.myAudio.pause();
        this.audioPlaying = false;
      }
    },
    nounString: function(str) {
      var nounList = ["-", ".", ",", "〜"];
      var newStr = "";

      for (var i = 0; i < str.length; i++) {
        var c = str.charAt(i);
        if (nounList.indexOf(c) == -1) {
          newStr += c;
        }
      }

      return newStr.trim();
    },
    /*
     * Runmode用スライダー初期化
     */
    sliderInit: function() {
      var self = this;
      this.swiperOut = new Swiper(".swiper-container1", {
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        on: {
          slideChange: function() {
            // ページングのアクティブなCSSクラスを削除して、現在のスライドと同じ要素番号のページ要素を取得
            var t = $(".swiper-pagination-bullet").removeClass("swiper-pagination-bullet-active").eq(self.swiperOut.realIndex);
            if (t) {
              // 現在のスライドの要素番号のページをアクティブにする
              t.addClass("swiper-pagination-bullet-active");
            }
          }
        }
      });

      this.swiperIn = new Swiper(".swiper-container2", {
        direction: "horizontal",
        spaceBetween: 0,
        nested: true,
        centeredSlides: true,
        slidesPerView: "auto",
        initialSlide: 0
      });
    },
    /**
     * 適用する"swiper-container"クラスを取得する
     * １段表示の場合は"swiper-container3"を２段表示の場合は"swiper-container2"を適用する
     *
     * @param obj 適用する"swiper-container"クラスを判断するためのObject
     * @return swiperClass 適用する"swiper-container"クラス
     *
     */

    getSwiperContainer: function(obj) {
      var swiperClass = "swiper-container";

      if (obj.length === undefined || obj.length === 1) {
        swiperClass += "3";
      } else {
        swiperClass += "2";
      }
      return swiperClass;
    },
    /**
     * ActiveなActにスライダーする
     */
    sliderToActiveAct: function(index) {
      this.log("runmode start sliderToActiveAct");

      index = this.getRtlLayoutSliderIndex(index);

      const self = this;

      return new Promise(function(resolve, reject) {
        if (self.isEnvironmentPc()) {
          resolve();
          return;
        }

        var targetIndex = index;
        var layoutObj = self.getLayoutObject(self.pathstep.layoutID);

        var swiperObj = [];
        for (var i = 0; i < layoutObj.actNums.length; i++) {
          for (var j = 0; j < layoutObj.actNums[i].length; j++) {
            swiperObj.push(layoutObj.actNums[i][j]);
          }
        }

        var swiperInSize = 0;
        if (self.swiperIn.length === undefined) {
          swiperInSize = 1;
        } else {
          swiperInSize = self.swiperIn.length;
        }

        if (swiperInSize === 1) {
          if (self.swiperIn.activeIndex == index) {
            resolve();
            return;
          }
        } else {
          if (self.swiperOut.activeIndex == 0) {
            if (self.swiperIn[self.swiperOut.activeIndex].activeIndex == index) {
              resolve();
              return;
            }
          } else {
            var currentIndex = 0;
            for (var i = 0; i < self.swiperOut.activeIndex + 1; i++) {
              if (i < self.swiperOut.activeIndex) {
                currentIndex += self.swiperIn[i].slides.length;
              } else {
                currentIndex += self.swiperIn[self.swiperOut.activeIndex].activeIndex + 1;
              }
            }
            if (currentIndex - 1 == index) {
              resolve();
              return;
            }
          }
        }

        if (swiperInSize === 1) {
          self.swiperIn.slideTo(targetIndex);

          self.swiperIn.on("slideChangeTransitionEnd", function() {
            resolve();
            return;
          });
        } else {
          for (var off = 0; off < swiperInSize && swiperObj[off] <= targetIndex; off++) {
            targetIndex -= swiperObj[off];
          }

          self.swiperOut.slideTo(off);
          self.swiperIn[off].slideTo(targetIndex);

          self.swiperOut.on("slideChangeTransitionEnd", function() {
            resolve();
            return;
          });
          self.swiperIn[off].on("slideChangeTransitionEnd", function() {
            resolve();
            return;
          });

          setTimeout(function() {
            resolve();
            return;
          }, 1000);
        }
      });
    },
    /**
     * 上段のAct数を取得する(1段表示の場合も含む)
     *
     * @param layoutObj レイアウト情報
     * @return 上段のAct数
     */
    getUpperActCount: function(layoutObj) {
      var upperActCount = 0;
      // Act数の取得
      for (var i = 0; i < layoutObj.actNums[0].length; i++) {
        upperActCount += layoutObj.actNums[0][i];
      }
      return upperActCount;
    },
    /**
     * 下段のAct数を取得する
     *
     * @param layoutObj レイアウト情報
     * @return 下段のAct数
     */
    getUnderActCount: function(layoutObj) {
      var underActCount = 0;
      if (layoutObj.actNums.length > 1) {
        // Act数の取得
        for (var i = 0; i < layoutObj.actNums[1].length; i++) {
          underActCount += layoutObj.actNums[1][i];
        }
      }
      return underActCount;
    },
    /**
     * 右から出題するレイアウトのスライダー対象のindex取得する
     *
     * @param index スライダー対象のACTのidenx
     */
    getRtlLayoutSliderIndex: function(index) {
      var layoutID = this.pathstep.layoutID;
      var rtlLayout = this.pathstep.rtlLayout;

      this.log("runmode start changeSliderIndex index: " + index + " layoutID: " + layoutID + " rtlLayout: " + rtlLayout);

      // 右から出題するレイアウトではない場合はindexをそのまま返却
      if (!rtlLayout) {
        return index;
      }

      var layoutObj = this.getLayoutObject(layoutID);
      if (layoutObj == null) {
        return index;
      }

      var sliderIndex = 0;

      // 上段／下段のAct数を取得する
      var upperActCount = this.getUpperActCount(layoutObj);
      var underActCount = this.getUnderActCount(layoutObj);

      if (upperActCount > index) {
        // 上段のActの場合
        sliderIndex = upperActCount - (index + 1);
      } else {
        // 下段Actの場合
        sliderIndex = upperActCount + underActCount - (index + 1 - upperActCount);
      }

      return sliderIndex;
    },
    /**
     * 右から出題するレイアウトのACT順序を変更する
     */
    changeRtlLayout: function() {
      var layoutID = this.pathstep.layoutID;
      var rtlLayout = this.pathstep.rtlLayout;

      this.log("runmode start changeRtlLayout layoutID: " + layoutID + " rtlLayout: " + rtlLayout);

      // 右から出題するレイアウトではない場合は処理終了
      if (!rtlLayout) {
        return;
      }

      var layoutObj = this.getLayoutObject(layoutID);
      if (layoutObj == null) {
        return;
      }

      // 上段／下段のAct数を取得する
      var upperActCount = this.getUpperActCount(layoutObj);
      var underActCount = this.getUnderActCount(layoutObj);

      // 上段の順序変更
      if (upperActCount != 0) {
        var itemList = [];
        for (var i = 1; i <= upperActCount; i++) {
          var item = "#Item" + (upperActCount - i);
          itemList.push(item);
        }

        for (var i = 0; i <= itemList.length; i++) {
          $(itemList[i]).after($(itemList[i + 1]));
        }
      }

      // 下段の順序変更
      if (underActCount != 0) {
        var itemList = [];
        for (var i = 1; i <= underActCount; i++) {
          var item = "#Item" + (underActCount + upperActCount - i);
          itemList.push(item);
        }

        for (var i = 0; i <= itemList.length; i++) {
          $(itemList[i]).after($(itemList[i + 1]));
        }
      }
    },
    /**
     * 対象の要素からFontクラスを取得する
     *
     * @param {Object} targetEle 取得対象の要素
     *
     * @return {String} 要素から取得したfontクラス名（fontクラスがない場合は空文字）
     */
    getTargetFontClass: function(targetEle) {
      this.log("Runmode start getTargetFontClass");
      
      var targetClass = targetEle.attr("class");
      var targetClassList = targetClass.split(' ');
      
      for(var i = 0; i < targetClassList.length; i++) {
        var ClassName = targetClassList[i];
        if(ClassName.match("font")) {
          this.log("Runmode end getTargetFontClass return ClassName: " + ClassName);
          return ClassName;
        }
      }
      
      this.log("Runmode end getTargetFontClass not fontClass");
      return ''
    },
    /**
     * 単語毎にポップアップ辞書イベントを登録した要素の文字列を返却する
     *
     * @param {String} ポップアップ辞書イベントを登録する文字列
     * @return 単語毎にポップアップ辞書イベントを登録した要素の文字列
     */
    getPopupTextElem: function(text) {
      // ポップアップ辞書を表示しない場合は処理終了(引数をそのまま返却する)
      if (popupDictionary.settings.popup === DIC_OPTIONS_DISABLED) {
        return text;
      }
      
      var popupText = "";
      var isTag = false;
      var endTagCount = 0;
      var word = "";
      var wordList = [];
      
      // 1文字毎に分割
      // （空白毎に分割した文字列の配列を取得する）
      // ※タグ内の空白は無視してタグの場合は開始タグから終了タグまで文字列結合する
      for (var chara of text) {
        word += chara;
        // 開始タグから終了タグまで文字列結合するためフラグを立てる
        if (chara === "<") {
          isTag = true;
        }
        if (chara === ">") {
          endTagCount += 1;
        }
        // 終了タグに達したらフラグを元に戻す
        if (endTagCount >= 2) {
          isTag = false;
          endTagCount = 0;
        }
        // タグ内ではなく空白だったら、次の単語を取得するためwordListに追加する
        if (!isTag && chara === " ") {
          wordList.push(word);
          word = "";
        }
      }
      // 最後の単語をwordListに追加する
      wordList.push(word);
      // 各単語毎にポップアップ辞書のイベントを付与する
      for (var word of wordList) {
        popupText += [
          "<span onmousemove='popupDictionary.popupMouseOver(event, this)'",
          "onmouseleave='popupDictionary.closeMouseOut()'",
          "onmouseup='popupDictionary.popupSelectedText(event)'",
          "onmousedown='popupDictionary.closeMouseClick()'>",
          word,
          "</span>"
        ].join(" ");
      }
      return popupText;
    },
    /**
     * 指定されたjQuery要素の行数を取得する
     *
     * @param {Object} targetElem jQuery要素
     *
     * @return {Number} 行数
     */
    getLineNumber: function(targetElem) {
      this.log("runmode start getLineNumber");
      let lineHeight = parseFloat(targetElem.css("line-height"));
      let elemHeight = targetElem.height();
      let result = elemHeight / lineHeight;
      this.log("line number : " + result);
      return result;
    },
    /**
     * 指定されたフォントサイズから補正したフォントサイズを取得する
     *
     * @param {Number} 補正対象フォントサイズ
     *
     * @return {Number} 補正済みフォントサイズ
     */
    getCorrectionFontSize: function(fontSize) {
      const AUTO_ADJUST_FONT_SIZE = mixinConstants.AUTO_ADJUST_FONT_SIZE[this.textSize];
      if (AUTO_ADJUST_FONT_SIZE.max <= fontSize) {
        return AUTO_ADJUST_FONT_SIZE.max;
      } else if (AUTO_ADJUST_FONT_SIZE.mid <= fontSize && fontSize < AUTO_ADJUST_FONT_SIZE.max) {
        return AUTO_ADJUST_FONT_SIZE.mid;
      } else {
        return AUTO_ADJUST_FONT_SIZE.min;
      }
    },
    /**
     * 自動調整されたフォントサイズを取得する
     *
     * @param {Object} targetFrame 対象テキスト表示領域
     * @param {Object} targetText 対象テキスト
     * @param {Number} fixedFontSize フォントサイズ
     *
     * @return {Number} 自動調整されたフォントサイズ
     */
    getAutoAdjustFontSize: function(targetFrame, targetText, fixedFontSize) {

      let result = fixedFontSize;

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return result;
      }

      // 行数を判定
      if (mixinConstants.MAX_LINE_NUMBER < this.getLineNumber(targetText)) {
        // 最大行数を超えていた場合、要素の高さを最大行数が収まる高さにする
        let lineHeight = parseFloat(targetText.css("line-height"));
        targetFrame.height(lineHeight * mixinConstants.MAX_LINE_NUMBER);

        // テキストが収まるように自動調整
        const AUTO_ADJUST_FONT_SIZE = mixinConstants.AUTO_ADJUST_FONT_SIZE[this.textSize];
        targetFrame.textfill({
          minFontPixels: AUTO_ADJUST_FONT_SIZE.min,
          maxFontPixels: AUTO_ADJUST_FONT_SIZE.max,
          allowOverflow: true
        });
      }

      // フォントサイズを確定させる
      let textFontSize = parseInt(targetText.css("font-size"), 10);
      if (textFontSize < fixedFontSize) {
        result = this.getCorrectionFontSize(textFontSize);
      }

      // 確定したサイズを返す
      return result;
    },
    /**
     * 自動調整された高さを取得する
     *
     * @param {Object} targetFrame 対象テキスト表示領域
     * @param {Object} targetText 対象テキスト
     * @param {Number} fixedHeight 対象テキスト表示領域の現在の高さ
     * @param {Number} fixedFontSize 対象テキストの現在のフォントサイズ
     *
     * @return {Number} 自動調整された高さ
     */
    getAutoAdjustHeight: function(targetFrame, targetText, fixedHeight, fixedFontSize) {

      let result = fixedHeight;

      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return result;
      }

      // 確定したフォントサイズを設定
      targetText.css({ fontSize: fixedFontSize });

      // カードの高さを確定させる
      let textAreaHeight = targetFrame.height();
      if (fixedHeight < textAreaHeight) {
        result = textAreaHeight;
      }

      // 確定したサイズを返す
      return result;
    },
    /**
     * カード領域のサイズを確定する
     *
     * @param {Object} targetTexts 対象テキスト連想配列
     * @param {Function} cloneCard 複製関数ポインタ
     * @param {Object} clones 複製する要素のポインタ
     */
    fixCardAreaSize: function(targetTexts, cloneCard, clones) {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return result;
      }

      // カードのフォントサイズを求める
      const MAX_AUTO_ADJUST_FONT_SIZE = mixinConstants.AUTO_ADJUST_FONT_SIZE[this.textSize].max;
      for (let displayMode in targetTexts) {
        for (let targetText of targetTexts[displayMode]) {
          if (targetText == "") {
            continue;
          }
          cloneCard(targetText);
          let cardAreaFontSize = this.cardAreaFontSize[displayMode] ? this.cardAreaFontSize[displayMode] : MAX_AUTO_ADJUST_FONT_SIZE;
          let adjustedFontSize = this.getAutoAdjustFontSize(clones.textArea, clones.text, cardAreaFontSize);
          this.cardAreaFontSize[displayMode] = adjustedFontSize;
          clones.card.remove();
        }
      }

      // カードの高さを求める
      for (let displayMode in targetTexts) {
        for (let targetText of targetTexts[displayMode]) {
          if (targetText == "") {
            continue;
          }
          cloneCard(targetText);
          let cardAreaHeight = this.cardAreaHeight[displayMode] ? this.cardAreaHeight[displayMode] : 0;
          let adjustedHeight = this.getAutoAdjustHeight(clones.textArea, clones.text, cardAreaHeight, this.cardAreaFontSize[displayMode]);
          this.cardAreaHeight[displayMode] = adjustedHeight;
          clones.card.remove();
        }
      }
    },
    /**
     * Tile表示テキストを取得する
     *
     * @param {String} language 言語コード
     * @param {String} defaultScript デフォルトスクリプトID
     *
     * @return {Object} Tile表示テキスト
     */
    getTileTexts: function(language, defaultScript) {
      let result = {};

      const self = this;

      // Tile表示テキスト生成
      const generateTileText = function(tileText) {
        let generatedText = "";
        for (let dividedText of self.getDividedTexts(tileText)) {
          if (self.isChoiceText(dividedText)) {
            generatedText += "<span class='input input1' />";
          } else {
            generatedText += dividedText;
          }
        }
        return generatedText;
      };

      const addResult = function(displayMode, tileText) {
        if (!result[displayMode]) {
          result[displayMode] = [];
        }
        result[displayMode].push(tileText);
      };

      const addResultRuby = function(actTexts, targetType) {
        let displayMode = self.getRubyDisplayMode(language);
        let target = self.getTextObjByScriptID(actTexts, language, targetType, displayMode, defaultScript);
        let questionText = generateTileText(target.textObj.tileText);
        if (target.pinyin) {
          // ピンイン付き表示
          let pinyinText = target.pinyin.tileText.replace(/\[([^\]]*)\]/g, "").replace(/ +/g, " ").trim();
          questionText = self.getChineseTextWithPinyin(questionText, pinyinText);
        }
        if (target.kana) {
          // ふりがな表示
          let superScripts = target.textObj.superScripts;
          let confusers = target.textObj.confusers;
          questionText = self.getJapaneseTextWithKana(questionText, superScripts, confusers);
        }
        addResult(displayMode, questionText);
      };

      for (let act of this.pathstep.acts) {
        if (this.isChallenge(act)) {

          // 全スクリプトIDのTile表示テキストを抽出
          for (let target of act.texts) {
            let scriptId = target.scriptID;
            let displayMode = this.getDisplayMode(language, scriptId, false);
            if (mixinConstants.DISPLAY_MODE_NONE == displayMode && scriptId != defaultScript) {
              // 表示モードが無い言語はデフォルトのスクリプトIDのみを対象とする
              continue;
            }
            addResult(displayMode, generateTileText(target.tileText));
          }

          // ルビ付きテキストを抽出
          switch (language) {
            case mixinConstants.LANGUAGE_CODE_ZHCV:
              for (let targetType of mixinConstants.SCRIPT_TYPE_LIST) {
                addResultRuby(act.texts, targetType);
              }
              break;
            case mixinConstants.LANGUAGE_CODE_JAJP:
              addResultRuby(act.texts, this.scriptType);
              break;
            default:
              // Ignore
              break;
          }

        }
      }

      return result;
    },
    /**
     * スペース毎のテキストを配列で取得する
     *
     * @param {String} targetText 対象テキスト
     *
     * @return {Array} 分割されたテキスト配列
     */
    getDividedTexts: function(targetText) {

      let result = [];

      let splitedTexts = targetText.replace(/\[/g, "####[").replace(/\]/g, "]####").split("####");

      for (let splitedText of splitedTexts) {
        if (splitedText) {
          result.push(splitedText);
        }
      }

      return result;
    },
    /**
     * 選択肢となるテキストかを判定する
     *
     * @param {String} targetText 対象テキスト
     *
     * @return {Boolean} true:選択肢となるテキスト, false:左記以外
     */
    isChoiceText: function(targetText) {
      return targetText.match(/\[([^\]]*)\]/g);
    },
    /**
     * 自動調整初期処理
     *
     * @param {Array} fontSelectors フォントサイズ初期化対象のセレクタ
     * @param {Array} invisibleSelectors 非表示対象のセレクタ
     */
    initAutoAdjust: function(fontSelectors, invisibleSelectors) {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }

      // フォントサイズを初期化
      const MAX_AUTO_ADJUST_FONT_SIZE = mixinConstants.AUTO_ADJUST_FONT_SIZE[this.textSize].max;
      for (let fontSelector of fontSelectors) {
        $(fontSelector).css({ fontSize: MAX_AUTO_ADJUST_FONT_SIZE });
      }
      // 自動調整処理中は非表示
      for (let invisibleSelector of invisibleSelectors) {
        $(invisibleSelector).css({ opacity: 0 });
      }
    },
    /**
     * 自動調整での最初の表示処理
     *
     * @param {Array} autoAdjustFuncs 実行する関数ポインタ
     * @param {Array} visibleSelectors 表示する要素のセレクタ
     */
    autoAdjustFirstShown: function(autoAdjustFuncs, visibleSelectors) {
      // PC版の場合は処理終了
      if (this.isEnvironmentPc()) {
        return;
      }
      // 自動調整済みの場合は処理終了
      if (this.isAutoAdjustShown) {
        return;
      }

      // 表示領域自動調整
      for (let autoAdjustFunc of autoAdjustFuncs) {
        autoAdjustFunc();
      }
      for (let visibleSelector of visibleSelectors) {
        $(visibleSelector).animate({ opacity: 1 }, 500);
      }
      this.isAutoAdjustShown = true;
    },
    /**
     * 指定されたjQueryセレクタの正確な高さを取得する
     * ~~~
     * jQuery(1.x.x)のouterHeightだと小数点以下含む正確な値が取得できず
     * 端末によってはレイアウトが崩れるためgetComputedStyleで高さを取得する
     * ~~~
     *
     * @param {String} selector 対象のセレクタ
     *
     * @return {Number} 指定されたjQueryセレクタの高さ
     */
    getComputedStyleHeight: function(selector) {
      return parseFloat(getComputedStyle($(selector).get(0), "").height);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixin/runmode.js